var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(
      _vm.$route.path != '/contratargeoguru' &&
        _vm.$route.path != '/geogurucontratado'
    )?_c('Navigation'):_vm._e(),_c('v-main',[_c('GeomiaHeader'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }